import SideSheetModal from "@/components/SideSheetModal";
import ListItem from "@/components/ListItem";
import SubSectionHeading from "@/components/SubSectionHeading";
import type { BackgroundCheckOrder } from "./types";
import OrderActivityTimeline from "./OrderActivityTimeline";
import OrderDateTimeDisplay from "./OrderDateTimeDisplay";
import { getScreeningResultLabel } from "./orderPresentation";

interface BackgroundCheckOrderSideSheetProps {
  open: boolean;
  order: BackgroundCheckOrder | null;
  onClose: () => void;
}

export default function BackgroundCheckOrderSideSheet({ open, order, onClose }: BackgroundCheckOrderSideSheetProps) {
  function setIsSideSheetOpen(isOpen: boolean) {
    if (!isOpen) onClose();
  }

  const screeningResult = order ? getScreeningResultLabel(order.updates ?? []) : "Pending";

  return (
    <SideSheetModal isSidebarOpen={open} setSidebarOpen={setIsSideSheetOpen} title="Screening Order" actions={null}>
      {order && (
        <div data-testid="background-check-order-side-sheet">
          <div className="flex w-full flex-col items-start gap-2">
            <SubSectionHeading>Overview</SubSectionHeading>
            <div className="w-full space-y-4" data-testid="background-check-order-summary-metrics">
              {order.providerId && (
                <ListItem
                  iconName="link"
                  iconBackground
                  overline="Provider ID"
                  headline={order.providerId}
                  longContent
                  copyable
                  copyText={order.providerId}
                  copyFieldLabel="Provider ID"
                />
              )}
              <ListItem
                iconName="event"
                iconBackground
                overline="Created"
                headline={<OrderDateTimeDisplay value={order.createdAt} />}
              />
              <ListItem iconName="fact_check" iconBackground overline="Screening Result" headline={screeningResult} />
            </div>
          </div>

          <div className="mt-8 flex w-full flex-col items-start gap-2">
            <SubSectionHeading badgeCount={(order.updates ?? []).length}>Activity</SubSectionHeading>
            <OrderActivityTimeline updates={order.updates ?? []} />
          </div>
        </div>
      )}
    </SideSheetModal>
  );
}
